/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Demo_Banner_ActionInputs */

const en_ui_demo_banner_action = /** @type {(inputs: Ui_Demo_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your own data`)
};

const de_ui_demo_banner_action = /** @type {(inputs: Ui_Demo_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Daten verwenden`)
};

/**
* | output |
* | --- |
* | "Use your own data" |
*
* @param {Ui_Demo_Banner_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_demo_banner_action = /** @type {((inputs?: Ui_Demo_Banner_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Demo_Banner_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_demo_banner_action(inputs)
	return de_ui_demo_banner_action(inputs)
});